// IMPORTANT - version number under the java API application.properties -> app.frontend.version -> must be kept in sync with this file
export const version = '3.3.06'
